import { render, staticRenderFns } from "./AppCardExpansible.vue?vue&type=template&id=db504ed2&scoped=true"
import script from "./AppCardExpansible.vue?vue&type=script&lang=js"
export * from "./AppCardExpansible.vue?vue&type=script&lang=js"
import style0 from "./AppCardExpansible.vue?vue&type=style&index=0&id=db504ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db504ed2",
  null
  
)

export default component.exports